<template>
<div class="chapter">
<div class="inner_page">
<div id="copyright">
<p>Text copyright © 2016 by Denise Gee.<br/>Photographs copyright © 2016 by Robert M. Peacock.</p>
<p>All rights reserved. No part of this book may be reproduced in any form without written permission from the publisher.</p>
<p>ISBN: 978-1-4521-3700-1 (epub, mobi)</p>
<p>Library of Congress Cataloging-in-Publication Data available.</p>
<p>ISBN: 978-1-4521-3296-9 (hc)</p>
<p>Designed by Stitch Design Co.<br/>Food and prop styling by Denise Gee</p>
<p>Chronicle Books LLC<br/>680 Second Street<br/>San Francisco, California 94107<br/><a href="http://www.chroniclebooks.com/" target="_blank">www.chroniclebooks.com</a></p>
<p><span class="font1"><span class="orange">Permissions</span></span><br/><span href="#/xhtml/16chapter07#page_31" title="Link target outside of Sample">Page 31</span>: Emeril’s Tomato Jam used with permission from Chef Emeril Lagasse.</p>
<p><span href="#/xhtml/31chapter21#page_60" title="Link target outside of Sample">Page 60</span>: Oysters Rockefeller Spinach Dip adapted from <em>The Cooking Club Cookbook</em> (Villard) with permission from author Katherine Fausset and Random House.</p>
<p><span href="#/xhtml/61chapter50#page_115" title="Link target outside of Sample">Page 115</span>: Pascal’s Manale BBQ Shrimp adapted from a recipe shared by New Orleans restaurant Pascal’s Manale, used with their permission.</p>
<p><span href="#/xhtml/62chapter51#page_116" title="Link target outside of Sample">Page 116</span>: Dickie Brennan’s Oyster Pan Roast used with permission from Chef Dickie Brennan of The Palace Café in New Orleans.</p>
<p><span href="#/xhtml/68chapter56#page_126" title="Link target outside of Sample">Page 126</span>: Stanley’s Juleps used with permission from author Stanley Dry.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05copyright.vue?65c6d6c4